import React, { PureComponent } from 'react';

import {
  Wrapper,
  PreTitle,
  Title,
  ContentContainer
} from '../components/ui';

import ImageSource from '../../../../containers/assets/peer-feedback-good-luck.png';

class ThatsAll extends PureComponent {
  render() {
    return (
      <Wrapper>
        <PreTitle>That’s All For Now!</PreTitle>
        <Title>That’s All For Now!</Title>
        <ContentContainer transparent={true}>
          <img src={ImageSource} alt="Strengths and Areas of Development" />
        </ContentContainer>
      </Wrapper>
    );
  }

}

export default ThatsAll;



// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/pages/thats-all.js